import { featuresItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">特色优势</h2>
        <p className="section-subtitle">为什么超过860万漫画爱好者选择在香蕉文化漫画网阅读</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-xl border border-background-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-5">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}